<template>
  <div>
    <div v-if="loadState === undefined">
      <div class="bill-pay__page-loader">
        <img src="/wp-content/themes/gmptwentynineteen/assets/images/loader-grey.svg" class="bill-pay__page-loader--svg" />
      </div>
    </div>
    <flow-error v-if="loadState === 'maintenance'" name="Stop Service" state="maintenance" phonetext="To stop service by phone call us at" closepath="/stop-service" />
    <flow-error v-if="loadState === 'error'" name="Stop Service" state="error" phonetext="To stop service by phone call us at" closepath="/stop-service" />
    <router-view v-if="loadState === 'complete'"></router-view>
    <!-- <div v-if="EnvironmentConstants.DevMode" class="bill-pay__temp-nav" style="padding: 20px">
      Links to subroutes (DEV mode only):
      <router-link to="/login">Login</router-link>
      <router-link to="/account">Account</router-link>
      <router-link to="/stop/1">Start, Stop, Or Move</router-link>
      <router-link to="/complete">Complete</router-link>
      <a @click="Logout()" href="javascript:void(0);">Logout</a>
    </div>-->
  </div>
</template>

<script>
import { EnvironmentConstants } from "../../environment";
import { DumpError, ReturnToSender } from "../../utilities";
import { GetComponentStatus } from '../../services/statuspage';

export default {
  name: "PageStopService",
  data() {
    return {
      EnvironmentConstants,

      loadState: undefined,
    };
  },
  watch: {
  },
  computed: {
    routeloading() {
      return this.$store.state.layout.routeloading;
    },
    isAdmin() {
      return !!this.$store.state.user.userinfo.isAdmin;
    },
  },
  async created() {
  },
  async mounted() {
    // Wire up the close button (outside of vue)
    const closer = document.querySelector("#flow-close");
    if (closer) {
      closer.addEventListener("click", e => {
        ReturnToSender('/stop-service');
      });
    }
    this.loadState = undefined;
    // Check for service outages
    const status = await GetComponentStatus("MyAccount");
    if (status === "operational" || this.isAdmin) {
      this.loadState = "complete";
    } else {
      this.loadState = status;
    }
  },
  methods: {
    async Logout() {
      try {
        await this.$store.dispatch("LogOut");
        this.$router.replace("/login");
      } catch (err) {
        DumpError("Logout error", err);
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>